import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class RolesQueryService {
    public GET_SPECIFIC_ID_BY_ROLE: any;

    constructor(public apollo: Apollo) {
        //get all roles 
        this.GET_SPECIFIC_ID_BY_ROLE = gql` 
            query GetReturnSelectedRole($roleName:String!) {
                allRoles(condition:{roleName:$roleName}) {
                    edges {
                        node {
                        roleName 
                        roleId
                        nodeId                        
                        usersByRoleId {
                            edges {
                            node {
                                firstName
                                lastName
                                email
                                password
                                createdAt
                                roleId
                                userId
                            }
                            }
                        }
                        }
                    }
                    }
            }
     `
            ;
    }
    GET_ROLE_ID_BY_ROLE_NAME(roleName) {
        return this.apollo.watchQuery({
            query: this.GET_SPECIFIC_ID_BY_ROLE,
            variables:
            {
                roleName: roleName,
            },
            fetchPolicy: 'network-only'
        })
    }

}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/roles.ts